export enum HORSES_FILTER {
    age = 'age',
    breed = 'breed',
    gender = 'gender',
    shoeing_cycle = 'shoeing_cycle',
    show_hidden = 'show_hidden',
}
